// builder-components.ts
import { Builder, withChildren } from '@builder.io/react';

import UnstyledCallCampaignWrapper from './unstyled-call-campaign-wrapper';

const UnstyledCallCampaignWrapperWithChildren = withChildren(
  UnstyledCallCampaignWrapper,
);

Builder.registerComponent(UnstyledCallCampaignWrapperWithChildren, {
  name: 'UnstyledCallCampaignWrapper',
  friendlyName: 'Unstyled Call Campaign Wrapper',
  noWrap: true,
  canHaveChildren: true,
});
